module.exports = __webpack_public_path__ + "static/aws-29c0ae782e09d4dc7316614881d5bae2.svg";